import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { AdminDashboard } from "@/pages/admin/dashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/admin/dashboard/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<AdminDashboard />
		</DashboardLayout>
	);
}
